import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ApplicationStatusCountsWidget } from '../../../application-status-counts/application-status-counts.widget';


@Component({
	selector: 'admissions-prospects-tab-1-part',
	standalone: true,
	imports: [ApplicationStatusCountsWidget],
	templateUrl: './admissions-prospects-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class AdmissionsProspectsTab1Part {
}
